import '../App.css';
import {useState, useEffect } from 'react'
import ChessBoard from 'chessboardjsx';
import Stockfish from '../components/StockFish.js';
import BlindBoard from '../components/BlindBoard.js';
import {  Stack } from '@mui/material'
import SinglePlayerSideBarRight from '../components/SideBars/SinglePlayerSideBarRight';
import SinglePlayerSideBarLeft from '../components/SideBars/SinglePlayerSideBarLeft';
import GameEndingModal from '../components/GameEndingModal';
import { useLocation } from "react-router-dom";
import ConfirmDialog from '../components/ConfirmDialog'
import opp from '../utils/opp.js';
import {opLastMove} from '../utils/lastMove'
import TopBar from '../components/SideBars/TopBar';
import SoundControls from '../components/SoundControls.js';


function SinglePlayerGame() {
    const loc = useLocation();
    const gameDetail = loc.state;
    const color = gameDetail.p1Color;
    const [gameMode] = useState(gameDetail.p1Mode);
    const [hints, setHints] = useState(parseInt(gameDetail.p1Hint));
    const [turn, setTurn] = useState(color === 'white')
    const [myLastMove, setMyLastMove] = useState('');
    const [gameResult, setGameResult] = useState('');
    const [gameResultDetail, setGameResultDetail] = useState('');
    const [gameState, setGameState] = useState('start');
    const [resignConfirmation, setResignConfirmation] = useState(false);  
    const [exitConfirmation, setExitConfirmation] = useState(false);
    const [boardWidth, setBoardWidth] = useState(calcBoardWidth)
    const [myTime, setMyTime] = useState({minutes: 0, seconds: 0});


    useEffect(() => {
      function handleResize() {
        setBoardWidth(calcBoardWidth());
    }

      // Size the board for the current viewport on mount (resize only fires later).
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onExport = (game) => () => {
        let result = '*';
        if (gameResult === 'draw') {
            result = "1/2-1/2"
        } else if ((gameResult === 'win' && color === 'white') || (gameResult === 'lose' && color === 'white')) {
            result = "1-0"
        } else {
            result = "0-1"
        }
        const date = new Date();

        game.header(
            'Site', 'ChessBlindly',
            'Result', result,
            'date', `${date.getFullYear()}.${date.getMonth()}.${date.getDate()}`,
            color, gameDetail.username,
            opp(color), `chessBlindly bot level ${gameDetail.botLevel}`
        )

        const data = {'pgn' : game.pgn()}
        const options = {
          method: "POST", 
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'}, 
          body: JSON.stringify(data)
        };
        
        fetch("https://lichess.org/api/import", options)
        .then((response) => response.json())
        .then((data) => window.open(data.url));
      }

      const handleResign = () => {
        setGameResult('lose');
        setGameState('end');
        setGameResultDetail('resignation');
        setResignConfirmation(false);
      }

    return (
        <>
        <header className="App-header">
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1369506265455012"
            crossorigin="anonymous"></script>
            <SoundControls/>
            <GameEndingModal result={gameResult} detail={gameResultDetail} open={gameState === 'end'} setOpen={setGameState}/>

            <ConfirmDialog title={'Resign'} description={'Are you sure that you want to resign?'} open={resignConfirmation && gameState !== 'afterGame'} setOpen={setResignConfirmation}  handleConfirm={handleResign}/>
            <ConfirmDialog title={'Exit'} description={'The game data will be lost, are you sure to exit?'} open={exitConfirmation && gameState === 'afterGame'} setOpen={setExitConfirmation} handleConfirm={() => {window.location.reload(false);}}/>

            <Stockfish color={color} setMyLastMove={setMyLastMove} setTurn={setTurn} setGameResult={setGameResult} setGameResultDetail={setGameResultDetail} setGameState={setGameState} onExport={onExport} botLevel={gameDetail.botLevel}>
                {({ position, onDrop, onBlindSubmit, game }) => (
                <>  
                <Stack direction={{ xs: 'column', md: 'row' }} spacing='50px'>
                    {/* <h1>{gameState}</h1> */}
                    <SinglePlayerSideBarLeft onExport={onExport(game)} setResignConfirmation={setResignConfirmation} time={myTime} gameState={gameState} setExitConfirmation={() => {}}/>
                    {(gameMode === 'Normal' || gameMode === 'Using hint...' || gameState === 'afterGame') ?
                        <Stack>
                            {boardWidth < 720 ?  <TopBar turn={turn} myTime={myTime} setMyTime={setMyTime} width={boardWidth} gameState={gameState} color={color} inverse={true} opponentName={`Bot Level: ${gameDetail.botLevel}`}/> : <></>}
                        <Board
                            width={boardWidth}
                            position={position}
                            onDrop={onDrop}
                            color={color}
                        />
                        </Stack>
                        :      
                    
                        <BlindBoard 
                            opLastMove={opLastMove(game.history(), color)} 
                            myLastMove={myLastMove}
                            setMyLastMove={setMyLastMove} 
                            submitMove={onBlindSubmit} 
                            isTurn={turn} 
                            hint={hints} 
                            useHint={() => setHints(hints - 1)} 
                            mode={gameMode} 
                        />
                    }
                <SinglePlayerSideBarRight onExit={() => setExitConfirmation(true)} setTime={setMyTime} onExport={onExport(game)} setResignConfirmation={setResignConfirmation} time={myTime} gameState={gameState} turn={turn} color={color} inverse={true} botLevel={gameDetail.botLevel}/>
                </Stack>
                </>  
            )}
            </Stockfish>
            
        </header>
        </>
    )
}

function Board({position, onDrop, color, width}) {
    return (
        <div className="App">
            <ChessBoard position={position} onDrop={onDrop} orientation={color} width={width} transitionDuration={150}
                lightSquareStyle={{ backgroundColor: '#dbe4ff' }} darkSquareStyle={{ backgroundColor: '#5b6bb5' }}/>
        </div>
    )
}


function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

// Board fills the viewport (minus a small margin) on narrow screens, capped at 720.
function calcBoardWidth() {
    const { width } = getWindowDimensions();
    return width < 720 ? width - 10 : 720;
  }


export default SinglePlayerGame;